export default __webpack_public_path__ + "static/media/delete-logo.6944ba8c.svg";